import React, { useContext } from 'react'
import { RadioButton } from './RadioButton'
import { TrajectoryConfigurationContext } from '../TrajectoryConfigurationContext'
import styles from './ButtonGroup.module.css'

interface ImageSelectionButtonGroupProps {
    loadLiveViewScreenshotHandler: () => Promise<void>
    removeLiveViewUrl: () => void
    setLatestImage: (latestImage: any | null | undefined) => void
}

export const ImageSelectionButtonGroup: React.FC<ImageSelectionButtonGroupProps> = ({
    loadLiveViewScreenshotHandler,
    removeLiveViewUrl,
    setLatestImage
}) => {
    const trajectoryConfigurationContext = useContext(TrajectoryConfigurationContext)

    const handleButtonClick = async (index: number, callback: () => void | Promise<void>) => {
        trajectoryConfigurationContext.setSelectedImageSource(index)
        await callback()
    }
    const selected = trajectoryConfigurationContext.selectedImageSource
    return (
        <div className={styles.root}>
            <RadioButton
                onClick={() =>
                    handleButtonClick(0, () => {
                        removeLiveViewUrl()
                        setLatestImage(false)
                    })
                }
                selected={selected === 0}
            >
                Latest Detection
            </RadioButton>
            <RadioButton onClick={() => handleButtonClick(1, loadLiveViewScreenshotHandler)} selected={selected === 1}>
                Live View Screenshot
            </RadioButton>
            <RadioButton
                onClick={() =>
                    handleButtonClick(2, () => {
                        removeLiveViewUrl()
                        setLatestImage(true)
                    })
                }
                selected={selected === 2}
            >
                Latest Daytime
            </RadioButton>
        </div>
    )
}
